
import React, { useState } from "react";

interface Parameter {
  id: number; // 🔥 IMPORTANT (needed for backend)
   symbol?: string;
  parameter: string;
  value: string;
}

interface Props {
  data: Parameter[];
  loading: boolean;
  onUpdate: (updated: Parameter[], index: number, field: string) => void;
}

const ParametersTable = ({ data, loading, onUpdate }: Props) => {
  const [editIndex, setEditIndex] = useState<number | null>(null);
  const [editField, setEditField] = useState<"parameter" | "value" | null>(null);
  const [editValue, setEditValue] = useState<string>("");

  //const rowColors = ["bg-white", "bg-blue-50"];
  const rowColors = ["bg-white", "bg-white"];

  const startEdit = (
    index: number,
    field: "parameter" | "value",
    value: string
  ) => {
    setEditIndex(index);
    setEditField(field);
    setEditValue(value ?? "");
  };

  const handleSave = (index: number) => {
    const updated = [...data];

    if (editField === "parameter") {
      updated[index].parameter = editValue;
    } else if (editField === "value") {
      updated[index].value = editValue;
    }

    onUpdate(updated, index, editField!);

    setEditIndex(null);
    setEditField(null);  
  };

  //if (loading) return <p className="text-gray-400">Loading...</p>;

  if (loading)
  return (
    <p
      className="text-gray-400"
      style={{
        fontFamily: "'Segoe UI', sans-serif",
        fontSize: "13px",
        fontWeight: 400,
      }}
    >
      Loading...
    </p>
  );
  // if (data.length === 0) return <p className="text-gray-400">No parameters found</p>;
  if (data.length === 0)
  return (
    <p
      className="text-gray-400"
      style={{
        fontFamily: "'Segoe UI', sans-serif",
        fontSize: "13px",
        fontWeight: 400,
      }}
    >
      No parameters found
    </p>
  );

  return (
    // <div className="rounded-2xl overflow-hidden shadow-lg border border-gray-200 bg-white/70 backdrop-blur-lg">
    <div>
      {/* <table className="w-full text-sm"> */}
      <table
  className="w-full"
  style={{
    fontFamily: "'Segoe UI', sans-serif",
    fontSize: "13px",
    fontWeight: 400,
  }}
>

       
       <thead className="bg-white border-b border-gray-300">
  <tr>
   {/* <th className="text-left px-4 py-3 font-bold text-black"> */}
   <th
  className="text-left px-4 py-3 text-black"
  style={{ fontWeight: 400 }}
>
      Parameter
    </th>
    {/* <th className="text-left px-4 py-3 font-bold text-black"> */}
    <th
  className="text-left px-4 py-3 text-black"
  style={{ fontWeight: 400 }}
>
      Symbol
    </th>

    {/* <th className="text-left px-4 py-3 font-bold text-black"> */}
    <th
  className="text-left px-4 py-3 text-black"
  style={{ fontWeight: 400 }}
>
      Value
    </th>
  </tr>
</thead>

        {/* BODY */}
        <tbody>
          {data.map((p, i) => (
            <tr
              //key={i}
              key={p.id}
              //className={`${rowColors[i % rowColors.length]} border-t border-white/40`}
             // className="bg-white"
             className="bg-white border-b border-gray-200"
            >
             
              <td className="px-4 py-1  text-gray-800">
  {p.parameter}
</td>
<td className="px-4 py-1 text-gray-800">
  {p.symbol || "-"}
</td>


              {/* 🔹 VALUE */}
              <td
                className="px-4 py-1  text-gray-900 cursor-pointer"
                onClick={() => startEdit(i, "value", p.value)}
              >
                {editIndex === i && editField === "value" ? (
                  <input
                    autoFocus
                   // className="border rounded px-2 py-1 w-full"
                   className="border rounded px-2 py-1 w-full"
  style={{
    fontFamily: "'Segoe UI', sans-serif",
    fontSize: "13px",
    fontWeight: 400,
  }}
                    value={editValue}
                    onChange={(e) => setEditValue(e.target.value)}
                    onBlur={() => handleSave(i)}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") handleSave(i);
                    }}
                  />
                ) : p.value ? (
                  Number(p.value).toFixed(2)
                ) : (
                  "-"
                )}
              </td>

            </tr>
          ))}
        </tbody>

      </table>
    </div>
  );
};

export default ParametersTable;

